import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getTable } from '../../api/api';
import { formatDate, truncateText } from '../../utils/helpers';

const NewsCard = ({ item }) => (
  <Link to={`/actualite/${item.slug}`} className="card">
    <div className="card-media">
      <img src={item.image_url} alt={item.title} loading="lazy" />
    </div>
    <div className="card-body">
      <span className="tag">{item.category}</span>
      <h3>{item.title}</h3>
      <p className="excerpt">{truncateText(item.excerpt || '', 130)}</p>
      <div className="card-meta">
        <span>{item.author}</span>
        <span>{formatDate(item.publish_date)}</span>
      </div>
    </div>
  </Link>
);

const NewsList = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // ✅ Correction: sort au lieu de 'sort=-publish_date'
        const res = await getTable('tables/news', { limit: 100, sort: '-publish_date' });
        setNews(res.data || []);
      } catch (e) {
        console.error('Erreur chargement actualités:', e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <section className="section">
        <div className="container">
          <div className="page-header">
            <h1>Actualités de l'AEII</h1>
          </div>
          <div className="grid grid-3">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="card" style={{ opacity: 0.6 }}>
                <div className="card-media" style={{ background: '#e1e5eb' }} />
                <div className="card-body">
                  <h3>Chargement...</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Accueil</Link> / Actualités
          </div>
          <h1>Actualités de l'AEII</h1>
          <p style={{ color: 'rgba(255,255,255,0.85)', maxWidth: '600px' }}>
            Suivez la vie de l'institut, nos événements et l'actualité économique africaine.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {news.length === 0 ? (
            <div className="empty-state">
              <i className="fa-solid fa-newspaper"></i>
              Aucune actualité pour le moment.
            </div>
          ) : (
            <div className="grid grid-3">
              {news.map((item) => (
                <NewsCard key={item.id} item={item} />
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default NewsList;